import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';
import { isEmpty } from 'lodash';
import MenuItem from '../../MenuItem/MenuItem';
import Select from '../../Select/Select';
import { EMPTY_OPTIONS } from './constants';

const useStyles = makeStyles({
  noPaddingLeft: {
    '& .MuiSelect-select': {
      paddingLeft: 0,
    },
  },
});

export const OperatorSelector = ({ value, style, onChange, options, fields, fieldName }) => {
  const classes = useStyles();

  const currentField = fields.find(({ name }) => name === fieldName);
  const isSelectEmpty = isEmpty(currentField.values) && currentField.valueEditorType === 'select';
  const filteredOptions = isSelectEmpty ? options.filter(({ name }) => EMPTY_OPTIONS.includes(name)) : options;

  return (
    <Select
      classes={{
      select: classes.noPaddingLeft,
    }}
      value={value}
      style={style}
      onChange={(e) => onChange(e.target.value)}
    >
      {filteredOptions.map(({ name, label, color }) => (
        <MenuItem key={name} value={name} title={label}>
          <span>
            <div className="query-builder-operator-indicator" style={{ backgroundColor: color }} />
            {label}
          </span>
        </MenuItem>
      ))}
    </Select>
  );
};

OperatorSelector.propTypes = {
  value: PropTypes.string,
  style: PropTypes.object,
  options: PropTypes.array,
  fields: PropTypes.array,
  onChange: PropTypes.func,
};
